import Nav from "../nav/nav.js";
import About from "../about/about.js";
import Projects from "../projects/projects.js";
import Footer from "../footer/footer.js";
import Education from "../education/education.js";
import Intro from "../intro/intro.js";
import ThreeScene from "../ThreeScene/ThreeScene.js";
import Experience from "../experience/experience.js";

const App = () => {
    return (
        <div className="container bg-bgLight dark:bg-bgDark dark:text-white text-gray-900 transition duration-300">
            <Nav/>
            <div  className="flex justify-between flex-wrap">
                <Intro/>
                <ThreeScene/>
            </div>
            <main>
                <About/>
                <Experience/>
                <Education/>
                <Projects/>
                <Footer/>
            </main>
        </div>
    )
}
export default App